import {endOfMonth, isAfter} from 'date-fns';

export const isGraduatedUser = (
  graduationYear: number,
  graduationMonth: number,
) => {
  // 指定された年月の最終日の23:59:59.999を取得
  const graduationDate = endOfMonth(
    new Date(graduationYear, graduationMonth - 1),
  );

  return isAfter(new Date(), graduationDate);
};
